import LoginForm from "./login-form.vue";

const promise = new Promise(resolve => {
  vueApp.component('login-form', LoginForm);
  resolve();
});

window.pendingComponentLoads.push(promise);